// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yRlX","textarea":"styles_textarea__-dxWa"};